export const corvidName = '$w.Section';
